import React, { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import '../CSS/Global.css';
import {
  IMAGE_ACCEPT_ATTR,
  IMAGE_TYPES_HELPER_TEXT,
  filterValidImageFiles,
} from '../utils/imageUploadRules';

const ImageUpload = ({ onImageUpload }) => {
  const [images, setImages] = useState([]);
  const toast = useToast();

  const appendFiles = async (rawFiles) => {
    const accepted = await filterValidImageFiles(rawFiles, (msg) => {
      toast({
        title: 'Image not accepted',
        description: msg,
        status: 'error',
        duration: 6000,
        isClosable: true,
        position: 'top',
      });
    });
    if (!accepted.length) return;
    setImages((prev) => {
      const next = [...prev, ...accepted];
      onImageUpload(next);
      return next;
    });
  };

  const handleImageUpload = (e) => {
    const files = e.target.files;
    e.target.value = '';
    appendFiles(files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    appendFiles(files);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className="image-upload-container">
      <p className="image-upload-hint" style={{ fontSize: '0.9rem', color: '#555', marginBottom: 12 }}>
        {IMAGE_TYPES_HELPER_TEXT}
      </p>
      <div
        className="drop-zone"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        style={{ border: '2px dashed #ccc', padding: '20px', minHeight: '150px' }}
      >
        <div className="upload-icon">
          <i className="fas fa-cloud-upload-alt"></i>
        </div>
        <label htmlFor="file-upload" className="browse-button">
          Upload
        </label>
        <input
          type="file"
          id="file-upload"
          multiple
          accept={IMAGE_ACCEPT_ATTR}
          onChange={handleImageUpload}
          style={{ display: 'none' }}
        />
      </div>

      <div className="preview">
        {images.length > 0 && <h4>Selected images</h4>}
        <div className="image-preview-grid">
          {images.map((image, index) => (
            <img
              key={index}
              src={URL.createObjectURL(image)}
              alt={`Uploaded ${index}`}
              className="image-preview"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageUpload;
